import { render, staticRenderFns } from "./InsolvencyPetitionDetails.vue?vue&type=template&id=4e447781&scoped=true&"
import script from "./InsolvencyPetitionDetails.vue?vue&type=script&lang=js&"
export * from "./InsolvencyPetitionDetails.vue?vue&type=script&lang=js&"
import style0 from "./InsolvencyPetitionDetails.vue?vue&type=style&index=0&id=4e447781&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e447781",
  null
  
)

export default component.exports